import React, {
  useEffect,
  useState,
  useImperativeHandle,
  forwardRef,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, notification, Form, Tooltip, Table, Button, Select } from "antd";
import FormInput from "../../../components/common/FormInput/FormInput";

import { getCdpData, saveCdpData } from "../../../redux/slices/cdpslice";
import {
  validationMessages,
  TEXT_CONSTANTS,
  NOTIFICATION_MESSAGES,
  CONFIRMATION_MESSAGES,
  PLACEHOLDER_TEXT,
  LIFETIMEOF_INITIATIVE_OPTIONS,
  LABEL_TEXT,
  API_BASE_URL,
} from "../../../constants/Constants";
import { CdpValidation } from "./SupplierUtil";
import { InfoCircleOutlined } from "@ant-design/icons";
import "./Cdp.css";
import axios from "axios";

const Cdp = forwardRef((props, ref, setIsDraft) => {

  const columns = [
    {
      title: 'Category',
      dataIndex: 'pillarMapping',
      key: 'pillarMapping',
      align: 'center'
    },
    {
      title: 'Scope 1 (tCO₂e)',
      dataIndex: 'scope1Emissions',
      key: 'scope1Emissions',
      align: 'right',
      render: (value) => Number(value).toLocaleString()
    },
    {
      title: 'Scope 2 Location-Based (tCO₂e)',
      dataIndex: 'scope2EmissionsLocation',
      key: 'scope2EmissionsLocation',
      align: 'right',
      render: (value) => Number(value).toLocaleString()
    },
    {
      title: 'Scope 2 Market-Based (tCO₂e)',
      dataIndex: 'scope2EmissionsMarket',
      key: 'scope2EmissionsMarket',
      align: 'right',
      render: (value) => Number(value).toLocaleString()
    }
  ];
  
  
  
  const dispatch = useDispatch();
  const {
    data: cdpData = {},
    loading,
    error,
  } = useSelector((state) => state.cdp);
  const [selectedYear, setSelectedYear] = useState(null);
  const [form] = Form.useForm();
    const supplierId = sessionStorage.getItem("supplierId")
    const [cdp,setCdpData]=useState();
    const [cdpByYear,setByYear]=useState();

  useEffect(() => {
    dispatch(getCdpData(supplierId));
  }, [dispatch]);

  useEffect(()=>{
    async function handleGetCDP() {
     
      try {
        const response = await axios.get(API_BASE_URL+`/CDP/${supplierId}`, {
         
          headers: {
            Authorization: `Bearer ${(sessionStorage.getItem("authToken"))}`,
            "Content-Type": "application/json"
          }
        });
    setCdpData(response.data)
  
        console.log("Cdp Data:", response.data);
      } catch (error) {
        console.error("Error fetching visitor data:", error);
      }
      
    }
    handleGetCDP();
  },[])

 

 

  if (loading) return <div>Loading...</div>;
console.log( cdpByYear);

  return (
    <div className="p-4 sm:p-6 lg:p-8 bg-white rounded-md shadow-sm">
    <Form form={form}>
      {/* Reporting Year Selector */}
      <Row gutter={[16, 16]} className="mb-6">
        <Col xs={24} sm={12}>
          <Form.Item
            label="Reporting Year"
            labelCol={{ style: { color: "#2C5778", fontWeight: "bold" } }}
            required
          >
            <Select
              placeholder="Select Year"
              
              className="w-full"
              onChange={(value) => {
                setByYear(cdp.cdpDetailsByYear[value]);
                setSelectedYear(value);
              }}
              value={selectedYear}
            >
              {cdp?.cdpDetailsByYear &&
                Object.keys(cdp.cdpDetailsByYear)
                  .sort((a, b) => b - a)
                  .map((year) => (
                    <Select.Option key={year} value={year}>
                      {year}
                    </Select.Option>
                  ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
  
      {/* CDP Score */}
      <div className="mt-6 flex items-center justify-between border-b pb-2">
  <span className="text-[#2C5778] text-base font-semibold">{TEXT_CONSTANTS.SCORE}</span>
  <span className="text-gray-800 text-base font-medium">{cdpByYear?.cdpScore ?? "-"}</span>
</div>

  
      {/* Emission Data Section */}
      <div className="mt-6">
        <h4 className="text-[#2C5778] text-lg font-semibold border-b pb-1">
          {TEXT_CONSTANTS.EMISSION_DATA}
        </h4>
        <div className="w-full mt-4 overflow-x-auto">
          <div className="min-w-[600px] max-w-5xl mx-auto">
            <Table
              dataSource={cdpByYear?.cdpTable.map((item, index) => ({ ...item, key: index })) || []}
              columns={columns}
              pagination={false}
              bordered
              className="w-full"
              summary={(pageData) => {
                let totalScope1 = 0;
                let totalScope2Location = 0;
                let totalScope2Market = 0;
  
                pageData.forEach(({ scope1Emissions, scope2EmissionsLocation, scope2EmissionsMarket }) => {
                  totalScope1 += Number(scope1Emissions) || 0;
                  totalScope2Location += Number(scope2EmissionsLocation) || 0;
                  totalScope2Market += Number(scope2EmissionsMarket) || 0;
                });
  
                return (
                  <Table.Summary fixed>
                    <Table.Summary.Row>
                      <Table.Summary.Cell index={0}><strong>Total</strong></Table.Summary.Cell>
                      <Table.Summary.Cell index={1} align="right">
                        {totalScope1.toLocaleString()}
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={2} align="right">
                        {totalScope2Location.toLocaleString()}
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={3} align="right">
                        {totalScope2Market.toLocaleString()}
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                  </Table.Summary>
                );
              }}
            />
          </div>
        </div>
      </div>
  
      <div className="mt-6 flex items-center justify-between border-b pb-2">
  <span className="text-[#2C5778] text-base font-semibold">{TEXT_CONSTANTS.COMMENTS}</span>
  <span className="text-gray-800 text-base font-medium text-right">{cdpByYear?.comments || "-"}</span>
</div>
    
      <div className="mt-6 flex items-center justify-between border-b pb-2">
  <span className="text-[#2C5778] text-base font-semibold">{TEXT_CONSTANTS.INTENSITY}</span>
  <span className="text-gray-800 text-base font-medium">{cdpByYear?.percentageOfIntensity ? `${cdpByYear.percentageOfIntensity}%` : "-"}</span>
</div>
    </Form>
  </div>
  
  );
});

export default Cdp;